import { LOCALES } from 'src/interfaces/i18n.types';

export const languageStateToLocalesMap: Record<string, LOCALES | undefined> = {
  EN: LOCALES.EN,
  ES: LOCALES.ES,
  FR: LOCALES.FR,
  IT: LOCALES.IT,
  KO: LOCALES.KR,
  RU: LOCALES.RU,
  'ZH-CN': LOCALES.CN,
  UK: LOCALES.UA,
};

export const LANGUAGE_SETTINGS_CHANGE_CHANNEL = 'language-settings-change';
